var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      !_vm.list.length && !_vm.preloader
        ? _c("no-orders")
        : _vm.preloader
          ? _c("loader")
          : _c(
              "div",
              { staticClass: "card" },
              [
                _c("div", { staticClass: "row align-center mb-30" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("histórico de limpezas")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "buttons-filters" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn bg-pink",
                          attrs: { to: { name: "purchase-flow" } }
                        },
                        [_vm._v("fazer novo pedido")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table mb-20" }, [
                  _c("table", [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Profissional")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Data e duração")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Endereço")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Status")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Ação")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.list, function(order) {
                        return _c("tr", { key: order.id }, [
                          _c("td", [
                            _c("div", { staticClass: "with-image" }, [
                              _c("img", {
                                attrs: {
                                  src:
                                    order.professional.account.profile
                                      .profile_picture
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "truncate" }, [
                                _vm._v(
                                  _vm._s(
                                    order.professional.account.first_name
                                  ) +
                                    " " +
                                    _vm._s(order.professional.account.last_name)
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDate")(
                                  order.schedule_event.starts_at,
                                  "DD/MM [às] H[h]"
                                )
                              ) +
                                " - " +
                                _vm._s(
                                  _vm._f("secToHours")(
                                    order.schedule_event.duration,
                                    true
                                  )
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "truncate" }, [
                            _vm._v(_vm._s(_vm._f("fullAddress")(order.address)))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("getTranslatedName")(order.status)
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "buttons", attrs: { nowrap: "" } },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "btn btn-small bg-purple-outline float-right",
                                  attrs: { to: "pedidos/" + order.id }
                                },
                                [_vm._v("ver mais")]
                              )
                            ],
                            1
                          )
                        ])
                      })
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("v-page", {
                  attrs: {
                    "page-size-menu": false,
                    info: false,
                    first: false,
                    last: false,
                    "total-row": _vm.pagination.totalResults,
                    value: _vm.pagination.current,
                    align: "center"
                  },
                  on: {
                    "page-change": function($event) {
                      _vm.setCurrentPage($event)
                    }
                  }
                })
              ],
              1
            )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09897b03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09897b03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderHistory/Desktop.vue
// module id = null
// module chunks = 